import { Ban, StepBack } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { isProduction } from '../../../config/config'
import {
  backApplication,
  deleteApplication,
  InsuranceApplication,
} from '../../../models/insuranceApplication'

interface InsuranceApplicationDevToolsProps {
  application: InsuranceApplication
}

export function InsuranceApplicationDevTools({ application }: InsuranceApplicationDevToolsProps) {
  if (isProduction) {
    return null
  }
  return (
    <>
      <div
        className="fixed bottom-4 left-4"
        onClick={() => deleteApplication(application!.id).then(() => window.location.reload())}
      >
        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant="destructive" size="icon">
              <Ban />
            </Button>
          </TooltipTrigger>
          <TooltipContent>Delete this application and start over.</TooltipContent>
        </Tooltip>
      </div>

      {application?.nextService !== application?.lastUsedService && application?.lastUsedService && (
        <div
          className="fixed bottom-4 left-14"
          onClick={() => backApplication(application!.id).then(() => window.location.reload())}
        >
          <Tooltip>
            <TooltipTrigger asChild>
              <Button variant="destructive" size="icon">
                <StepBack />
              </Button>
            </TooltipTrigger>
            <TooltipContent>Go back to the previous step.</TooltipContent>
          </Tooltip>
        </div>
      )}
    </>
  )
}
